import DMB_API from './api';

export const platos_api = {
    getPlatosCom: function (comercio) { 
        return DMB_API.get(comercio, {}, {})
    .then(response => ((response.data.status === 'success') ? response.data.regs : []))
    .catch(error => console.log(error))}
}